<template>
  <div class="failure-single-content">
    <div class="self-amount-section">
      <div
        class="header row"
        :class="{'success': isSelfLoanSuccess, 'failure': !isSelfLoanSuccess}"
        @click="selfLoanHeaderAction"
      >
        <img :src="selfLoanStatusIcon" class="icon">
        <div class="text">
          <span v-html="selfLoanStatusDesc"></span>
        </div>
      </div>
      <div class="info">
        <div class="item row" v-for="(item, index) in infoKeyValues" :key="index">
          <div class="title">{{item.title}}</div>
          <div class="value">{{item.value}}</div>
        </div>
      </div>
    </div>
    <div
      class="up-amount-section header row"
      :class="{'success': isUpLoanSuccess, 'failure': !isUpLoanSuccess}"
    >
      <img :src="upLoanStatusIcon" class="icon">
      <div class="text" @click="upLoanHeaderAction" data-sensors-click>
        <span v-html="upLoanStatusDesc"></span>
      </div>
    </div>
  </div>
</template>

<script>
import successIcon from '../../image/icon_checkmark_circle_fill_green.png'
import failureIcon from '../../image/icon_exclamationmark_circle_fill_red.png'

export default {
  props: {
    result: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    infoKeyValues () {
      const selfLoanInfo = this.result.processLoanInfos.filter(item => this.isEmptyString(item.riskBizTagType))[0]
      return [
        {
          title: '借款金额',
          value: this.formatMoney(selfLoanInfo.applyAmount) || '0.00'
        },
        {
          title: '借款期限',
          value: selfLoanInfo.dueTime + '个月'
        },
        {
          title: '借款日期',
          value: this.formatDate(selfLoanInfo.loanDate)
        },
        {
          title: '放款借据',
          value: selfLoanInfo.platBillNo
        }
      ]
    },
    isSelfLoanSuccess () {
      const selfLoanInfo = this.result.processLoanInfos.filter(item => this.isEmptyString(item.riskBizTagType))[0]
      return selfLoanInfo?.loanStatusVoEnum === 'LOAN_PASSED'
    },
    isUpLoanSuccess () {
      const upLoanInfo = this.result.processLoanInfos.filter(item => item.riskBizTagType === 'UP_CARD')[0]
      return upLoanInfo?.loanStatusVoEnum === 'LOAN_PASSED'
    },
    selfLoanStatusIcon () {
      return this.isSelfLoanSuccess ? successIcon : failureIcon
    },
    upLoanStatusIcon () {
      return this.isUpLoanSuccess ? successIcon : failureIcon
    },
    selfLoanStatusDesc () {
      return this.isSelfLoanSuccess
        ? '<span>已放款成功，查看详情 ></span>'
        : '<span>很抱歉，该笔订单放款失败，<span style="color: #FF4633">重新提现 ></span></span>'
    },
    upLoanStatusDesc () {
      return this.isUpLoanSuccess
        ? '<span>您有一笔提额额度放款成功, 去查看 ></span>'
        : this.result.upCardRealTimeRefund === 'Y' ? '<span>提额额度放款失败，已为您申请退款</span>' : '<span>提额额度放款失败, <span style="color: #FF4633">去退款 ></span></span>'
    }
  },
  methods: {
    selfLoanHeaderAction () {
      if (this.isSelfLoanSuccess) {
        this.$router.push({
          path: '/repayment/history',
          query: {}
        })
      } else {
        this.$router.push('/withdraw/index')
      }
    },
    upLoanHeaderAction () {
      if (this.result.upCardRealTimeRefund === 'Y') {
        return
      }
      if (this.isUpLoanSuccess) {
        this.$router.push({
          path: '/repayment/history',
          query: {}
        })
      } else {
        this.$emit('onUpLoanFailure')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.failure-single-content{
  .self-amount-section {
    .header {
      border-radius: 10px 10px 0px 0px;
      height: 76px;
    }
    .info {
      background: #FAFAFA;
      border-radius: 0px 0px 20px 20px;
      padding: 40px;
    }
  }
  .up-amount-section {
    height: 76px;
    border-radius: 10px;
    margin-top: 20px;
  }
  .header {
    padding: 0 19px;
    align-items: center;
    justify-content: flex-start;
    .icon {
      width: 40px;
      height: 40px;
    }
    .text {
      margin-left: 11px;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 40px;
    }
  }
  .item {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 53px;
    .title {
      color: #666666;
      width: 162px;
    }
    .value {
      color: #333333;
      width: 448px;
      word-break: break-all;
    }
  }
  .row {
    display: flex;
    flex-direction: row;
  }
  .success {
    background: #EEF6EE;
  }
  .failure {
    background: #FFF8F7;
  }
  .text-red {
    color: #FF4633;
  }
}
</style>